import { Theme } from "../../../components/constants";

export default {
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    actionsRow: { 
        display: 'flex', 
        justifyContent: 'space-between' 
    },
    leftContainer: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '15px' 
    },
    rightContainer: { 
        display: 'flex', 
        gap: '15px', 
        alignItems: 'center' 
    },
    grid: { 
        padding: '30px 10px' 
    }

}